import {Component, inject, Input} from '@angular/core';
import {MatchParticipant} from '../../../../../../model/events/MatchParticipant';
import {Match} from '../../../../../../model/events/Match';
import {MatchService} from '../../../../../../services/match.service';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {Button} from 'primeng/button';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-kratzer-teilnehmer',
  standalone: true,
  templateUrl: './kratzer-teilnehmer.component.html',
  imports: [
    Button,
    TranslateModule
  ],
  styleUrls: ['./kratzer-teilnehmer.component.scss']
})
export class KratzerTeilnehmerComponent
{
  private matchService = inject(MatchService);
  private restErrorHelper = inject(RestErrorHelper);

  @Input() match: Match;
  @Input() matchParticipant: MatchParticipant;
  @Input() editable: boolean;

  isSaving: boolean;

  onLossClicked(): void
  {
    if (!this.editable)
      return;

    console.log('onLossClicked');
    const data = {...this.matchParticipant};
    if (data.resultLoss)
      data.resultLoss = false;
    else
      data.resultLoss = true;

    this.setMatchResult([data]);
  }

  private setMatchResult(participants: MatchParticipant[]): void
  {
    this.isSaving = true;

    this.matchService.setMatchParticipantsResult(this.match.id, participants).subscribe({
      next: () =>
      {
        console.log('Ergebnisse gesetzt');
        this.isSaving = false;
      },
      error: error =>
      {
        this.isSaving = false;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }
}
